module.exports = __webpack_public_path__ + "img/meituan.5a71f55a.png";